<!-- routes/ComingSoon/CNY.svelte -->
<script>
  import { onMount } from "svelte";
  import Header from "lib/components/Header.svelte";
  import Footer from "lib/components/Footer.svelte";
  import { trackEvent } from "utils/analytics.js";
  import Clarity from "@microsoft/clarity";
  import { initCachedBranch } from "lib/modules/Contact.svelte";

  // Import the new modular components
  import Hero from "./Hero.svelte";
  import Comparison from "./Comparison.svelte";
  import PreregisterForm from "./PreregisterForm.svelte";

  onMount(() => {
    if (Clarity) {
      Clarity.setTag("Flow", "CNY");
      console.log("Microsoft Clarity tag set: Flow = CNY");
    }
    initCachedBranch();
    trackEvent("PageView", {
      page: "GoldRemittanceLanding",
      market: "China",
    });
  });
</script>

<svelte:head>
  <title>Send Gold to China - Liquid Noble Gold-Backed Remittance</title>
  <meta
    name="description"
    content="Send gold instantly to family and friends in China. Buy gold with AUD, USD, EUR, GBP and more. Recipients can sell for CNY and receive payouts via Alipay or UnionPay. Launching soon - preregister for exclusive discounts."
  />
  <meta
    name="keywords"
    content="send gold China, gold remittance, Alipay gold, UnionPay gold, CNY gold transfer, precious metals China"
  />
</svelte:head>

<Header showLanguageSwitcher />

<Hero />

<Comparison />

<PreregisterForm />

<Footer />
